import { render, staticRenderFns } from "./MiniProgramNav.vue?vue&type=template&id=4e9ce972&scoped=true"
import script from "./MiniProgramNav.vue?vue&type=script&lang=js"
export * from "./MiniProgramNav.vue?vue&type=script&lang=js"
import style0 from "./MiniProgramNav.vue?vue&type=style&index=0&id=4e9ce972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9ce972",
  null
  
)

export default component.exports